import { MD5, AES, mode, pad, enc } from 'crypto-js';

export const md5 = (text: string): string => {
    return MD5(text).toString();
}